import React from 'react'

export const ModuleActionsContext = React.createContext({
  handleCopyModule: () => {},
  handleAssignModuleToDate: () => {},
  handleDuplicateModuleToDate: () => {},
  handleCopyModuleToTemplate: () => {},
})
